import React, { useEffect, useRef, useState } from 'react';
import FormInputWrapper from 'components/FormInputWrapper';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import useDetectOutsideClick from 'hooks/useDetectOutsideClick';
import Text from 'components/Text';
const Datepicker = (props) => {
    const { onChange, label, defaultValue } = props;
    const datepickerRef = useRef(null);
    const [isOpen, setIsOpen] = useDetectOutsideClick(false, datepickerRef);
    const [startDate, setStartDate] = useState(new Date());
    useEffect(() => {
        onChange(startDate);
    }, [onChange, startDate]);
    useEffect(() => {
        if (defaultValue) {
            setStartDate(new Date(defaultValue));
        }
    }, [defaultValue]);
    const handleDateChange = (date) => {
        setIsOpen(false);
        setStartDate(date);
    };
    return (React.createElement("div", { className: "datepicker", "data-testid": "datepicker", ref: datepickerRef },
        React.createElement(FormInputWrapper, { label: label, icon: "calendar", inputWrapperClassName: isOpen ? 'datepicker-open' : '', onIconClick: () => setIsOpen(!isOpen) },
            React.createElement(Text.Base, null, format(startDate, 'dd-MM-yyyy'))),
        isOpen && (React.createElement("div", { className: "datepicker-wrapper", "data-testid": "datepicker-opened" },
            React.createElement(DatePicker, { selected: startDate, onChange: handleDateChange, calendarStartDay: 1, inline: true })))));
};
export default Datepicker;
